import { api } from '@smena/ui';

export type PaymentKind = 'subscription' | 'setup' | 'whitelabel' | 'other';

export const PAYMENT_KIND_LABELS: Record<PaymentKind, string> = {
  subscription: 'Подписка',
  setup: 'Внедрение',
  whitelabel: 'White-label',
  other: 'Прочее',
};

export interface Payment {
  id: string;
  accountId: string;
  accountSlug: string | null;
  accountName: string | null;
  amountRub: number;
  kind: PaymentKind;
  periodFrom: string | null;
  periodTo: string | null;
  paidAt: string;
  method: string | null;
  note: string | null;
  createdByEmail: string | null;
  createdAt: string;
}

export interface Revenue {
  paidToday: number;
  paidThisMonth: number;
  paidLast30: number;
  expectedMrr: number;
  byMonth: Array<{ month: string; amountRub: number }>;
  byKind: Array<{ kind: string; amountRub: number; count: number }>;
  unpaidAccounts: Array<{
    accountId: string;
    slug: string;
    name: string;
    expectedRub: number;
    lastPaidAt: string | null;
  }>;
}

export interface PaymentInput {
  accountId: string;
  amountRub: number;
  kind: PaymentKind;
  periodFrom?: string | null;
  periodTo?: string | null;
  paidAt?: string | null;
  method?: string | null;
  note?: string | null;
}

export async function fetchPayments(accountId?: string): Promise<Payment[]> {
  const qs = accountId ? `?account=${accountId}` : '';
  const r = await api<{ items: Payment[] }>(`/api/admin/payments${qs}`);
  return r.items;
}

export function createPayment(input: PaymentInput): Promise<Payment> {
  return api<Payment>('/api/admin/payments', { method: 'POST', json: input });
}

export function deletePayment(id: string): Promise<void> {
  return api(`/api/admin/payments/${id}`, { method: 'DELETE' });
}

export function fetchRevenue(): Promise<Revenue> {
  return api<Revenue>('/api/admin/analytics/revenue');
}
